import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import list from "../../../../api/feed/list";
import CustomButton from "../../../../components/CustomButton";
import SearchBar from "../../../../components/List/components/SearchBar";
import {connect} from "react-redux";
import {styled} from "@mui/styles";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import SidebarFloatMenu from "../../../../components/NewSidebar/components/SidebarContent/components/SidebarFloatMenu";
import FeedTypeCreationList from "./components/FeedTypeCreationList";
import MappingMissingButton from "./components/MappingMissingButton";
import DemoFeedTableRow from "./components/DemoFeedTableRow";
import FeedActions from "./components/FeedActions";
import {greyishBlue50} from "../../../../assets/jss/main";
import {useHistory} from "react-router-dom";
import ProductMappingStats from "components/ProductMappingStats";
import {FeedListContext} from "./FeedListContext";

ListDemo.propTypes = {
    
};

function ListDemo(props) {
    const [feeds, setFeeds] = useState([]);
    const [filteredFeeds, setFilteredFeeds] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [search, setSearch] = useState(null);

    function refreshFeeds() {
        if (!props.retailer?.id) return Promise.resolve();

        return list(`pagination=false&draft=false&retailer.id=${props.retailer.id}`)
            .then((response) => setFeeds(response));
    }

    function handleClick(event){
        setAnchorEl(event.currentTarget);
    }

    useEffect(() => {
        refreshFeeds();
    }, [props.retailer]);

    useEffect(() => {
        setFilteredFeeds(feeds);
    }, [feeds]);

    useEffect(() => {
        if (!search) {
            setFilteredFeeds(feeds)
        } else {
            setFilteredFeeds(feeds.filter((feed) => feed.name.toLowerCase().includes(search)))
        }
    }, [search]);


    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        backgroundColor:'#f9f9fa',
    }));

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        color: '#6B7280',
        textTransform: "uppercase",
        fontSize: '12px',
    }));

    return (
        <FeedListContext.Provider value={{refreshFeeds}}>
            <div style={{
                marginLeft:'240px',
                display: 'flex',
                flexDirection: 'column',
                padding: '24px'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: '12px'
                }}>
                    <MappingMissingButton retailer={props.retailer} />
                    <CustomButton onClick={handleClick}>
                        <span style={{marginRight: '16px'}}>+</span>
                        <span>Ajouter un flux</span>
                    </CustomButton>
                </div>
                {/*  <ProductMappingStats retailerId={props.retailer?.id} />*/}
                <div style={{marginTop: '24px'}}>
                    <div style={{width: '384px'}}>
                        <SearchBar
                            customPlaceholder={'Rechercher un flux...'}
                            iconSize={14}
                            onChange={(value) => setSearch(value)}
                        />
                    </div>
                </div>
                <div style={{marginTop: '24px'}}>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>ID</StyledTableCell>
                                    <StyledTableCell>fichier</StyledTableCell>
                                    <StyledTableCell>#références</StyledTableCell>
                                    <StyledTableCell>Statut</StyledTableCell>
                                    <StyledTableCell>Dernier import</StyledTableCell>
                                    <StyledTableCell align="right">Actions</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {filteredFeeds.length === 0 ? (
                                    <TableRow>
                                        <TableCell
                                            component="th"
                                            scope="row"
                                            colSpan={6}
                                            sx={{textAlign: 'center'}}
                                        >
                                            Aucun flux
                                        </TableCell>
                                    </TableRow>
                                ) : filteredFeeds.map((feed) => (
                                    <DemoFeedTableRow feed={feed} key={feed.id} />
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                <SidebarFloatMenu
                    anchorEl={anchorEl}
                    open={!!anchorEl}
                    onClose={() => setAnchorEl(null)}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    style={{
                        '.MuiPaper-root' : {
                            padding: '0px'
                        },
                    }}
                >
                    <FeedTypeCreationList />
                </SidebarFloatMenu>
            </div>
        </FeedListContext.Provider>
    );
}


const mapStateToProps = state => {
    const {
        retrieved,
        loading,
        error,
    } = state.feed.list;

    const {deleted} = state.feed.del;
    const deleteLoading = state.feed.del.loading;
    const deletedMapperItem = state.mapper.del.deleted;
    const createdMapperItem = state.mapper.create.created;
    const importingProductSuccess = state.feed.importProduct.importing;

    return {
        retrieved,
        loading,
        error,
        deletedItem: deleted,
        deleteLoading,
        deletedMapperItem,
        createdMapperItem,
        importingProductSuccess,
        updated: state.feed.update.updated,
        retailer: state.retailer.show.retrieved,
    };
};

export default connect(
    mapStateToProps,
    null
)(ListDemo);
